/** Sidebar widths — keep in sync with Header offset calculations */
export const NAV_DRAWER_WIDTH = 260;
export const NAV_DRAWER_WIDTH_COLLAPSED = 72;

/** Below this breakpoint the nav is a temporary overlay (closed by default). */
export const MOBILE_NAV_BREAKPOINT: 'md' = 'md';
